import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { AdornisTemplater } from '@adornis/templater/server/index.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { GlobalSetting } from '../entities/global-setting.js';
import { Participation } from '../entities/Participation.js';
import type { User } from '../entities/user.js';

export const generateMultiCertificate = registerMutation({
  operationName: 'generateMultiCertificate',
  type: () => String,
  params: [{ name: 'participationsIDs', type: () => [String] }],
  resolve: (participationIDs: string[]) => async () => {
    const user = await CurrentUserInfo.getMyself<User>()({ _id: 1, firstName: 1, lastName: 1 });
    if (!user) throw new Error('user not found');

    const participations = await (() => {
      // used to generate certificate-preview
      if (participationIDs[0] === 'testing_1' && participationIDs[1] === 'testing_2') {
        return [
          { _id: 'testing_1', userID: user._id, product: { name: 'workshop1' } },
          { _id: 'testing_2', userID: user._id, product: { name: 'workshop2' } },
        ];
      }

      return getByID(Participation, participationIDs)({ _id: 1, userID: 1, product: { name: 1 } });
    })();

    // do not allow to mix participations from different users
    for (const participation of participations) {
      if (participation.userID !== user._id) {
        throw new Error('user is not allowed to generate certificates for other users');
      }
    }

    const eventNames = participations.map(participation => {
      if (!participation.product) throw new Error('Participation has no product');
      return participation.product.name;
    });

    const globalSettings = await GlobalSetting.getGlobalSetting()({ multiCertTemplateID: 1 });
    if (!globalSettings.multiCertTemplateID) throw new Error('No template found');
    const templateFile = await getByID(AdornisFile, globalSettings.multiCertTemplateID)(AdornisFile.allFields);
    if (!templateFile) throw new Error('No template-file found ' + globalSettings.multiCertTemplateID);
    const templater = AdornisTemplater.fromFile(templateFile.getFullPath());
    templater.render({ vorname: user.firstName, nachname: user.lastName, ['event-namen']: eventNames });
    const pdfBuffer = await templater.toPdfBuffer();
    const file = await AdornisFile.createFromBuffer(pdfBuffer, 'global-certificate.pdf');
    await file.save();
    return file._id;
  },
});
